module.exports = __webpack_public_path__ + "img/2-2.2c4b477a.png";